// src/app/slices/gasHeaterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GasHeaterState, IGasHeater, IGasHeaterParams } from '../models';

const initialState: GasHeaterState = {
  gasHeaters: {},
  gas_heater_params: null,
};

const gasHeaterSlice = createSlice({
  name: 'gas_heater',
  initialState,
  reducers: {
    setGasHeater: (state, action: PayloadAction<IGasHeater>) => {
      state.gasHeaters[action.payload.id] = {
        ...action.payload,
        params: action.payload.gas_heater_params
          ? JSON.parse(action.payload.gas_heater_params)
          : '',
      };
    },
    setGasHeaterParams: (state, action: PayloadAction<IGasHeaterParams>) => {
      state.gas_heater_params = action.payload;
    },
  },
});

export const { setGasHeater, setGasHeaterParams } = gasHeaterSlice.actions;

export default gasHeaterSlice.reducer;
